import { type IMessagesType, messagesDe } from "@domain/intl/translations/de";
import { messagesEn } from "@domain/intl/translations/en";
import { messagesRu } from "@domain/intl/translations/ru";

export { useTranslation, type MessageId } from "@domain/intl/useTranslation";
export type { IMessagesType } from "@domain/intl/translations/de";

export enum Lang {
    En = "en",
    De = "de",
    Ru = "ru",
}

export interface ILocaleMessages {
    messages: IMessagesType;
    locale: Lang;
}

const MessagesDe: ILocaleMessages = {
    locale: Lang.De,
    messages: messagesDe,
};
const MessagesRu: ILocaleMessages = {
    locale: Lang.Ru,
    messages: messagesRu,
};
const MessagesEn: ILocaleMessages = {
    locale: Lang.En,
    messages: messagesEn,
};

export const getLocaleMessages = (lang: Lang) => {
    let messages: ILocaleMessages = MessagesDe;
    switch (lang) {
        case Lang.En:
            messages = MessagesEn;
            break;
        case Lang.Ru:
            messages = MessagesRu;
            break;
    }
    return messages;
};
